import { render, staticRenderFns } from "./verproyectos.vue?vue&type=template&id=a4990902"
import script from "./verproyectos.vue?vue&type=script&lang=js"
export * from "./verproyectos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports